import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Analytics from "@/components/Analytics";
import { useSite } from "@/context/SiteContext";

export default function Layout() {
  const { config } = useSite();
  return (
    <div className="flex min-h-screen flex-col bg-[#0A0A0B]">
      <Analytics config={config} />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
